import React from "react";

export default function NonFinancialNotice() {
  return (
    <p className="text-sm text-gray-500">
      دعاوی خانوادگی، امور حسبی و غیرمالی، بین ۳۰۰,۰۰۰ تا ۴,۰۰۰,۰۰۰ ریال است.
      مقدار برآوردی بر اساس ضرایب زیر محاسبه می‌شود.
    </p>
  );
}
